import { render, staticRenderFns } from "./fenban.vue?vue&type=template&id=52584120&scoped=true"
import script from "./fenban.vue?vue&type=script&lang=js"
export * from "./fenban.vue?vue&type=script&lang=js"
import style0 from "./fenban.vue?vue&type=style&index=0&id=52584120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52584120",
  null
  
)

export default component.exports